<template>
  <el-header class="titlte">
    <div class="titlte_first">
      <img src="@/assets/home_logo.png" alt="logo" class="logo" />
      <div class="button_all">
        <button
          v-for="item in navButtons"
          :key="item.path"
          class="title-button"
          :class="{ active: activePath === item.path }"
          type="text"
          @click="go(item.path)"
        >
          {{ item.label }}
        </button>
      </div>
    </div>

    <div class="titlte_first">
      <el-popover
        placement="bottom"
        popper-class="contact-popover"
        trigger="hover"
        v-model:visible="isDropdownOneOpen"
      >
        <template #default>
          <div class="contact-box">
            <div class="contact-title">Contact us</div>
            <button class="contact-btn" @click="openExternalLink(TGNumber)">
              <img src="@/assets/img_tg.svg" alt="telegram" />
              @{{ tgUsername }}
            </button>
          </div>
        </template>

        <!-- 触发元素 -->
        <template #reference>
          <div
            class="divimg_style"
            :style="{
              backgroundColor: isDropdownOneOpen ? '#ffffff1a' : 'transparent',
            }"
          >
            <img src="@/assets/img_lin.png" alt="linlogo" class="linlogo" />
          </div>
        </template>
      </el-popover>

      <el-dropdown
        @command="handleCommand"
        class="user-dropdown"
        @visible-change="handleVisibleChange"
      >
        <span
          class="el-dropdown-link"
          :style="{
            backgroundColor: isDropdownOpen ? '#ffffff1a' : 'transparent',
          }"
        >
          {{ currentUser }}
          <img
            :src="isDropdownOpen ? arrowUp : arrowDown"
            alt="arrow"
            class="arrow-icon"
          />
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              v-for="user in userList"
              :key="user.merchantId"
              :command="{ type: 'switch', value: user }"
              :class="{ 'is-active': currentUser === user.merchantName }"
            >
              {{ user.merchantName }}
            </el-dropdown-item>

            <el-dropdown-item
              divided
              disabled
              class="divider-item"
            ></el-dropdown-item>

            <el-dropdown-item :command="{ type: 'action', value: 'changePwd' }">
              Change Password
            </el-dropdown-item>
            <el-dropdown-item :command="{ type: 'action', value: 'logout' }">
              Logout
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </el-header>
  <el-dialog
    v-model="isChangePwdDialogVisible"
    :show-close="false"
    class="custom-dialog"
    align-center
  >
    <div class="header">
      <div class="changepwd">Change Password</div>
      <img
        src="@/assets/img_close.svg"
        @click="isChangePwdDialogVisible = false"
        style="cursor: pointer"
      />
    </div>
    <!-- Logo 和标题 -->
    <el-form
      :model="changepwdForm"
      @submit.prevent="onLogin"
      class="el_formmmm"
    >
      <!-- 用户名输入框 -->
      <span class="text_tig">Initial Password</span>
      <el-form-item prop="username">
        <el-input
          v-model="changepwdForm.password"
          class="custom-input"
          type="password"
        ></el-input>
      </el-form-item>

      <!-- 密码输入框 -->
      <span class="text_tig">New Password</span>
      <el-form-item prop="password">
        <el-input
          v-model="changepwdForm.newPassword"
          class="custom-input"
          type="password"
        ></el-input>
      </el-form-item>
      <span class="text_tig">Confirm new Password</span>
      <el-form-item prop="password">
        <el-input
          v-model="changepwdForm.cpnfirmPassword"
          class="custom-input"
          type="password"
        ></el-input>
      </el-form-item>
      <!-- 登录按钮 -->
      <el-form-item>
        <el-button class="login-button" @click="updateInfoData">
          Confirm modification</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  removeToken,
  removeUserName,
  getCurrentUser,
  getUserInfoList,
  clearUserData,
  setCurrentUser,
  setCurrencyCode,
} from "@/stores/auth";
import arrowDown from "@/assets/arrow-down.png";
import arrowUp from "@/assets/arrow-up.png";
import {
  getValueByKey,
  getCurrencyCode,
  updateInfo,
  logoutApi,
} from "@/api/topApi";
import { ElMessage } from "element-plus";

const TGNumber = ref(""); // 当前选择的用户名
const changepwdForm = ref({
  password: "",
  newPassword: "",
  cpnfirmPassword: "",
});
const router = useRouter();
const route = useRoute();
// 获取用户信息
const fetchgetValueByKey = async () => {
  try {
    const response = await getValueByKey();
    if (response.code === 200) {
      TGNumber.value = response.msg; // 设置到 ref
    }
  } catch (error) {
    console.error("失败:", error);
  }
};
const fetchgetCurrencyCode = async () => {
  try {
    const response = await getCurrencyCode();
    if (response.code === 200) {
      setCurrencyCode(response.data);
    }
  } catch (error) {
    console.error("失败:", error);
  }
};
const updateInfoData = async () => {
  if (changepwdForm.value.newPassword !== changepwdForm.value.cpnfirmPassword) {
    ElMessage.error("Passwords do not match");
    return;
  }
  try {
    const response = await updateInfo(changepwdForm.value);
    if (response.code === 200) {
      logout();
    } else {
      ElMessage.error(response.msg);
    }
  } catch (error) {
    console.error("失败:", error);
  }
};

// 从完整链接里提取用户名
const tgUsername = computed(() => {
  if (!TGNumber.value) return "";
  return TGNumber.value.replace("https://t.me/", "");
});
// 导航按钮
const navButtons = [
  { label: "HOME", path: "/dashboard" },
  { label: "Order information", path: "/analytics" },
  { label: "Players place bets", path: "/settings" },
];

// 当前路由 path
const activePath = computed(() => route.path);

// 存储用户信息
const userList = ref([]); // 接口返回的用户列表
const currentUser = ref(""); // 当前选择的用户名
function refreshPage() {
  window.location.reload();
}
function fetchUserInfo() {
  const response = getUserInfoList();
  const storedUser = getCurrentUser(); // 改名字，避免覆盖
  userList.value = response || [];
  if (storedUser) {
    currentUser.value = storedUser.merchantName; // 设置到 ref
  } else if (response?.length) {
    currentUser.value = response[0].merchantName; // 没存过就默认第一个
  }
  fetchgetCurrencyCode();
}

function go(path) {
  if (route.path !== path) {
    router.push(path);
  }
}

const isDropdownOpen = ref(false);
const handleVisibleChange = (visible) => {
  isDropdownOpen.value = visible;
};

const isDropdownOneOpen = ref(false);
const isChangePwdDialogVisible = ref(false);

const handleCommand = async (command) => {
  if (command.type === "switch") {
    currentUser.value = command.value.merchantName; // 切换用户
    setCurrentUser(command.value);
    await fetchgetCurrencyCode(); // 等待数据更新完成
    refreshPage(); // 然后刷新
  } else if (command.type === "action") {
    if (command.value === "logout") {
      logOutApi();
    } else if (command.value === "changePwd") {
      isChangePwdDialogVisible.value = true;
    }
  }
};
const logOutApi = async () => {
  try {
    await logoutApi();
    logout();
  } catch (error) {
    console.error("失败:", error);
  }
};
const logout = () => {
  removeToken();
  removeUserName();
  clearUserData();
  router.push("/");
};

const openExternalLink = (url) => {
  window.open(url, "_blank");
};

const onLogin = async () => {};

onMounted(() => {
  fetchUserInfo();
  fetchgetValueByKey();
});
</script>

<style>
.el-dropdown-menu__item.is-active {
  color: #8e67ea !important; /* 文字高亮色 */
}
.custom-dialog {
  border-radius: 8px !important; /* 圆角 */
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto !important;
  min-width: 0 !important;
  display: inline-block; /* 让宽度随内容 */
}

.el-dropdown-menu__item {
  color: #9fa1a8 !important;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
}
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: #ffffff !important;
  color: #8e67ea !important;
}
.el-dropdown-menu__item--divided {
  height: auto;
  padding: 0 !important;
  margin: 0 15px !important;
  margin-top: 12px !important;
}
.el-dropdown-menu__item--divided hr {
  border: none;
  border-top: 1px solid #dce3ea;
  margin: 0;
}
.el-popper__arrow {
  display: none !important;
}
.contact-popover {
  min-width: auto !important;
  width: auto !important;
  padding: 0 !important;
  border-radius: 8px !important;
}
</style>
<style scoped>
.titlte {
  height: 56px;
  background-color: #131432;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.titlte_first {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo {
  width: 96.55px;
  height: 20px;
  margin-left: 120px;
}
.el-dropdown-link {
  margin-right: 120px;
  height: 56px;
  color: #ffffff;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 100%;
  padding: 0 8px;
  letter-spacing: 0%;
  display: inline-flex;
  align-items: center;
  outline: none;
  box-shadow: none;
}
.button_all {
  margin-left: 131px;
  display: flex;
  gap: 8px;
}
.linlogo {
  width: 15.82px;
  height: 15.26px;
}
.el-header {
  --el-header-padding: 0px;
  --el-header-height: 0px;
}
.title-button {
  background-color: transparent;
  color: #ffffff;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  height: 32px;
  border: none;
  padding: 0 24px;
  border-radius: 20px;
}

.title-button:hover {
  background-color: #3d3e57;
}

.title-button.active {
  background-color: #ffffff;
  color: #131432;
}

.user-dropdown {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
.arrow-icon {
  width: 6.39px;
  height: 3.3px;
  margin-left: 7px;
  display: inline-block;
}
.contact-title {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000000;
}
.contact-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #8e67ea;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 10px 24px;
  cursor: pointer;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  white-space: nowrap;
  margin-top: 12px;
}

.contact-btn img {
  width: 15.9;
  height: 13.5;
}
.contact-box {
  display: inline-block;
  background: #fff;
  border-radius: 8px;
  padding: 12px 16px;
  /* margin-top: -6px; */
}
.divimg_style {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 10px;
  margin-right: 26px;
}

.login_title {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 600;
  font-style: Semibold;
  font-size: 30px;
  line-height: 100%;
  color: #333333;
  margin-top: 32px;
  max-width: 424px;
}

.text_tig {
  margin-top: 24px;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: -0.31px;
}
.el-form-item {
  margin-bottom: 27px; /* 默认值，可能是 20px 或 24px，视版本而定 */
}
.login-button {
  width: 472px;
  height: 56px;
  background: #8e67ea;
  border: none;
  color: #ffffff;
  border-radius: 12px;
  font-size: 16px;
}
.login-button:hover {
  background-color: #8e67ea;
  color: #ffffff;
  font-size: 16px;
}
.custom-input {
  width: 472px;
  height: 56px;
  margin-top: 8px;
  --el-input-focus-border-color: #8e67ea;
}

::v-deep(.el-input__inner) {
  color: #333333;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: -0.31px;
}
::v-deep .el-input__wrapper {
  border-radius: 12px; /* 设置圆角 */
}
.header {
  display: flex;
  justify-content: space-between; /* 左右两端对齐 */
  align-items: center; /* 垂直居中 */
}
.changepwd {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #333333;
}
.el_formmmm {
  margin-top: 30px;
}
</style>
